import { render, staticRenderFns } from "./Stopwatch.vue?vue&type=template&id=509e19a5&scoped=true"
import script from "./Stopwatch.vue?vue&type=script&lang=js"
export * from "./Stopwatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e19a5",
  null
  
)

export default component.exports